var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.264 24.1821V27.7956C22.264 28.2748 22.0699 28.7343 21.7245 29.0732C21.379 29.412 20.9104 29.6024 20.4219 29.6024H7.52656L2 35.0226V16.955C2 16.4759 2.19409 16.0163 2.53956 15.6775C2.88504 15.3386 3.35361 15.1483 3.84219 15.1483H7.52656M35.1593 22.3753L29.6328 16.955H16.7375C16.2489 16.955 15.7803 16.7647 15.4349 16.4259C15.0894 16.087 14.8953 15.6275 14.8953 15.1483V4.30773C14.8953 3.82855 15.0894 3.369 15.4349 3.03016C15.7803 2.69133 16.2489 2.50098 16.7375 2.50098H33.3171C33.8057 2.50098 34.2743 2.69133 34.6198 3.03016C34.9652 3.369 35.1593 3.82855 35.1593 4.30773V22.3753Z",
    stroke: "#5F5F5F",
    strokeWidth: 3.1884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.a344019291d13eb232ef1fd168d5ad1e.svg";
export { ForwardRef as ReactComponent };